import { render } from "./main-navbar.vue?vue&type=template&id=1037e569&ts=true"
import script from "./main-navbar.vue?vue&type=script&lang=ts"
export * from "./main-navbar.vue?vue&type=script&lang=ts"

import "./main-navbar.vue?vue&type=style&index=0&id=1037e569&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__